export default "__VITE_ASSET__kwFDwnTk__"